import React from "react";

/**
 * Onboarding In Progress marker glyph.
 *
 * Drawn as three pieces rather than one solid triangle: the gap between the upper and
 * lower body is the cone's reflective band, and it is what stops the shape reading as
 * a warning triangle at 10px. Same 24x24 grid as WrenchIcon so the pair match in
 * weight inside the same tile.
 *
 * Fill is currentColor and props are spread onto the <svg> so the colour can come from
 * org config via the wrapper's `color`.
 */
// `name` is destructured away because CustomIcon spreads its whole props
// object, which would otherwise put name="status-..." on the <svg>.
const TrafficConeIcon = ({ size = 10, name, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path fill="currentColor" d="M12 2.4 15.08 11.2H8.92Z" />
        <path fill="currentColor" d="M8.01 13.8h7.98l1.61 4.6H6.4Z" />
        <path
            fill="currentColor"
            d="M3.2 18.9h17.6a1.45 1.45 0 0 1 0 2.9H3.2a1.45 1.45 0 0 1 0-2.9z"
        />
    </svg>
);

export default TrafficConeIcon;
